    'use strict';

    function Recaptcha2Invisible(recaptcha2ContainerId, siteKey) {
        this.recaptcha2ContainerId = recaptcha2ContainerId;
        this.siteKey = siteKey;
        this.widgetId = null;
        this.token = '';
        this.callback = null;

        this.init();
    }

    Recaptcha2Invisible.prototype.init = function () {
        this.widgetId = window.grecaptcha.render(this.recaptcha2ContainerId, {
            "sitekey": this.siteKey,
            "size": 'invisible',
            "badge": 'inline',
            "callback": this.recaptchaCallback.bind(this)
        });
    }

    Recaptcha2Invisible.prototype.recaptchaCallback = function (token) {
        if (this.callback) this.callback(token);
    }

    Recaptcha2Invisible.prototype.execute = function (callback) {
        this.callback = callback;

        window.grecaptcha.reset(this.widgetId);
        window.grecaptcha.execute(this.widgetId);
    }    
